import { IAppState } from '../../redux';

export const selectIsJKValid = (state: IAppState): boolean => {
  // корпус привязан (введено имя)
  const isJKFulfilled = !!state.offer.geo?.jk?.house?.id;

  const isJKClean = !state.offer.geo?.jk;

  /** Определяет валидность введенного ЖК для коммерческих категорий с бизнес-центрами */
  return isJKFulfilled || isJKClean;
};
